import { useTheme } from "@emotion/react";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { useSocketContext } from "context/SocketContext";
const FooterHome = ({ position }) => {
  const { palette, ...theme } = useTheme();
  const { unreadNotificationCount } = useSocketContext();

  const socialLinks = [
    {
      name: "Discord",
      link: "https://discord.com/invite/3P5K3dzgdB",
    },
    {
      name: "X/(Twitter)",
      link: "https://x.com/yugalabs",
    },
    {
      name: "Youtube",
      link: "https://www.youtube.com/@YugaLabs",
    },
    {
      name: "Instagram",
      link: "https://www.instagram.com/yugalabs/",
    },
  ];
  const links = [
    {
      name: "CONTACT",
      navigate: "/contactUs",
    },
    {
      name: "ABOUT",
      navigate: "/about",
    },
    {
      name: "TICKETS",
      navigate: "/tickets",
    },
  ];
  return (
    <>
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          width: "100%",
          cursor: "var(--pointer-default)",
          background: "#000",
          zIndex: "10000 !important",
          [theme.breakpoints.down("lg")]: {
            display: "flex",
            flexDirection: "column",
            padding: "0px",
          },
        }}
      >
        <div>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingInline: "2vw",
                marginInline: "auto",
                [theme.breakpoints.down("md")]: {
                  paddingInline: "1px",
                },
              }}
            >
              <Box
                sx={{
                  display: "contents",
                  flexDirection: "row",
                  alignItems: "center",
                  minWidth: "150px",
                }}
              >
                {socialLinks.map((link, i) => (
                  <a
                    key={i}
                    style={{
                      verticalAlign: "center",
                      cursor: "var(--pointer-cursor)",
                      fontFamily: "var(--font-g)",
                      color: "#fff",
                    }}
                    href={link.link}
                    target="_blank"
                    className="btn-flip"
                    data-back={link.name}
                    data-front={link.name}
                  ></a>
                ))}
              </Box>
              <Typography
                sx={{
                  cursor: "var(--pointer-cursor)",
                  fontFamily: "var(--font-g)",
                  fontSize: ".75rem",
                  color: "#adadaf",
                  display: "flex",
                  textAlign: "center",
                  alignItems: "center",
                  justifyContent: "center",
                  marginInline: "auto",
                  [theme.breakpoints.down("md")]: {
                    fontSize: "10px",
                    justifyContent: "flex-end",
                  },
                }}
              >
                Powered by{" "}
                <img
                  style={{
                    marginInline: "16px",
                    height: "0.9vw",
                    width: "auto",
                  }}
                  onClick={() => {
                    window.open("https://apechain.com/", "_blank");
                  }}
                  variant="square"
                  src="https://storage.googleapis.com/3d-container/ApechainHighRes.svg"
                  alt="Ape chain"
                  loading="lazy"
                />{" "}
                <img
                  style={{
                    height: "10px",
                    width: "auto",
                  }}
                  onClick={() => {
                    window.open("https://dashbo.xyz", "_blank");
                  }}
                  variant="square"
                  src="https://ishrostorage.blob.core.windows.net/container-3d/Logo.png"
                  alt="Dashbo"
                  loading="lazy"
                />{" "}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  minWidth: "150px",
                }}
              >
                {links.map((link, i) => {
                  return (
                    <Link
                      key={i}
                      style={{
                        verticalAlign: "center",
                        cursor: "var(--pointer-cursor)",
                        fontFamily: "var(--font-g)",
                        color: "#fff",
                      }}
                      to={link.navigate}
                      className="btn-flip"
                      data-back={link.name}
                      data-front={
                        link.name === "TICKETS" && unreadNotificationCount > 0
                          ? `${link.name} 🟠`
                          : link.name
                      }
                    ></Link>
                  );
                })}
              </Box>
            </Box>
          </Box>
        </div>
      </Box>
    </>
  );
};

export default FooterHome;
